import Tool from '@recogito/annotorious/src/tools/Tool';
import RubberbandEllipse from 'components/ImageViewer/annotorious/tools/ellipse/rubberbandEllipse';
import { isEllipseAnnotation } from 'components/ImageViewer/annotorious/tools/ellipse/ellipseUtils';
import EditableEllipse from 'components/ImageViewer/annotorious/tools/ellipse/editableEllipse';

/**
 * A rubberband selection tool for creating ellipse annotations.
 * Registered on the Annotorious instance with `anno.addDrawingTool(...)`.
 */
export default class RubberbandEllipseTool extends Tool {
  constructor(g, config, env) {
    super(g, config, env);

    this.rubberband = null;
  }

  startDrawing = (x, y) => {
    this.attachListeners({
      mouseMove: this.onMouseMove,
      mouseUp: this.onMouseUp,
    });

    this.rubberband = new RubberbandEllipse(
      x,
      y,
      this.g,
      this.config,
      this.env,
    );
  };

  stop = () => {
    if (this.rubberband) {
      this.rubberband.destroy();
      this.rubberband = null;
    }
  };

  onMouseMove = (x, y) => {
    // Constrain coordinates to the image bounds
    const { naturalWidth, naturalHeight } = this.env.image;
    const constrainX = Math.min(Math.max(x, 0), naturalWidth);
    const constrainY = Math.min(Math.max(y, 0), naturalHeight);

    this.rubberband.dragTo(constrainX, constrainY);
  };

  onMouseUp = () => {
    this.detachListeners();
    this.started = false;

    const { width, height } = this.rubberband.getBoundingClientRect();

    const minWidth = this.config.minSelectionWidth || 4;
    const minHeight = this.config.minSelectionHeight || 4;

    if (width >= minWidth && height >= minHeight) {
      const { element } = this.rubberband;
      element.annotation = this.rubberband.toSelection();

      this.emit('complete', element);
    } else {
      this.emit('cancel');
    }

    this.stop();
  };

  get isDrawing() {
    return this.rubberband != null;
  }

  createEditableShape = (annotation, formatters) =>
    new EditableEllipse(
      annotation,
      this.g,
      { ...this.config, formatters },
      this.env,
    );
}

RubberbandEllipseTool.identifier = 'ellipse';

RubberbandEllipseTool.supports = (annotation) =>
  isEllipseAnnotation(annotation);
